import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "/src/hooks/navigation";
import ExpiredSessionComponent from "../../components/expired-session";
import { logoutThunk } from "../../redux/actions/auth-actions";

function ExpiredSession() {
  const dispatch = useDispatch();
  const { navigate } = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      setOpen(true);
    };

    window.addEventListener("sessionExpired", handleSessionExpired);

    return () => {
      window.removeEventListener("sessionExpired", handleSessionExpired);
    };
  }, []);

  const handleOnClose = () => {
    dispatch(logoutThunk());
    setOpen(false);
    navigate("/");
  };

  const goToSignInPage = () => {
    dispatch(logoutThunk());
    setOpen(false);
    navigate("/signin");
  };

  return <ExpiredSessionComponent open={open} onClose={handleOnClose} onAccept={goToSignInPage} />;
}

export default ExpiredSession;
